// 클라이언트 사전 축소 헬퍼
// -----------------------------------------------------------------------------
// 업로드 전 브라우저에서 긴 변 1600px 이내로 축소해 전송량을 줄인다. 최종 리사이즈·
// WebP 변환은 서버(sharp)가 담당하므로 여기서는 JPEG 0.85 로만 줄인다. 디코드에
// 실패하는 포맷(HEIC 등)은 원본 File 을 그대로 돌려주고 서버 판단에 맡긴다.
// -----------------------------------------------------------------------------

const MAX_EDGE = 1600;

// 이미지 소스를 <img> 로 로드 (createImageBitmap 실패 시 폴백)
const loadViaImg = (file) =>
   new Promise((resolve, reject) => {
      const url = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => {
         URL.revokeObjectURL(url);
         resolve(img);
      };
      img.onerror = () => {
         URL.revokeObjectURL(url);
         reject(new Error('image decode failed'));
      };
      img.src = url;
   });

export const resizeImage = async (file) => {
   if (!file || !file.type || !file.type.startsWith('image/')) {
      return file;
   }
   try {
      let source;
      let width;
      let height;
      try {
         source = await createImageBitmap(file);
         width = source.width;
         height = source.height;
      } catch (e) {
         const img = await loadViaImg(file);
         source = img;
         width = img.naturalWidth;
         height = img.naturalHeight;
      }

      if (!width || !height) return file;

      const longEdge = Math.max(width, height);
      const scale = longEdge > MAX_EDGE ? MAX_EDGE / longEdge : 1;
      const targetW = Math.round(width * scale);
      const targetH = Math.round(height * scale);

      const canvas = document.createElement('canvas');
      canvas.width = targetW;
      canvas.height = targetH;
      const ctx = canvas.getContext('2d');
      if (!ctx) return file;
      ctx.drawImage(source, 0, 0, targetW, targetH);
      if (source.close) source.close();

      const blob = await new Promise((resolve) =>
         canvas.toBlob(resolve, 'image/jpeg', 0.85)
      );
      if (!blob) return file;

      const newName = file.name ? file.name.replace(/\.[^.]+$/, '') + '.jpg' : 'upload.jpg';
      return new File([blob], newName, { type: 'image/jpeg' });
   } catch (e) {
      // 디코드/캔버스 실패 → 원본 그대로, 서버에 위임
      return file;
   }
};
